
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cardprocessingoffers",
      function () {
        return require("private-next-pages/cardprocessingoffers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cardprocessingoffers"])
      });
    }
  